import React from "react";
import Header from "../Header/Header";
import Search from "./Search";
import classes from "./Banner.module.css";

const Banner = () => {

  return (
    <header className={classes.header}>
      <Header />
      <section className={classes[`header-description`]}>
        <h2 className={classes.name}>pixelbay</h2>
        <h4 className={classes.slogan}>
          Stunning free images shared by talented creators
        </h4>
        <h4 className={classes.credit}>
          Powered by <strong>Unsplash</strong>
        </h4>
      </section>
      <Search search="banner" size="24"/>
    </header>
  );
};

export default Banner;
